export function eventbus(
    config
) {
    const bus = {}

    const on = (key, handler) => {
        if (bus[key] === undefined) {
            bus[key] = []
        }
        bus[key]?.push(handler)

        return () => {
            off(key, handler)
        }
    }

    const off = (key, handler) => {
        const index = bus[key]?.indexOf(handler) ?? -1
        bus[key]?.splice(index >>> 0, 1)
    }

    const once = (key, handler) => {
        const handleOnce = (payload) => {
            handler(payload)
            off(key, handleOnce )
        }

        on(key, handleOnce)
    }

    const emit = (key, payload) => {
        bus[key]?.forEach((fn) => {
            try {
                fn(payload)
            } catch (e) {
                config?.onError(e)
            }
        })
    }

    return { on, off, once, emit }
}
